const createSlugFromText = (text: string) => text.toLowerCase()
  .replace(/[^a-z ]/g, '')
  .split(' ')
  .filter((e) => e)
  .join('-');

export default createSlugFromText;
